import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function MenuProducts({ children }) {
  useInjectSaga({ key: 'menuProducts', saga });
  useInjectReducer({ key: 'menuProducts', reducer });

  return React.Children.only(children);
}

MenuProducts.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withMenuProducts } from './withMenuProducts';
export default compose(withConnect, memo)(MenuProducts);
